import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Real MSAL imports
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';

// We always initialize the real MSAL instance.
// Our components will decide whether to use it or the dummy logic.
const msalInstance = new PublicClientApplication(msalConfig);

const rootElement = document.getElementById('root')!;
const root = ReactDOM.createRoot(rootElement);

// Always wrap the app in the real MsalProvider.
// This ensures that the MSAL hooks are always available,
// even if we decide not to use them in dummy mode.
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </React.StrictMode>
);